// Maps the app's ISO-639-3 language codes to the BCP-47 tags that the
// Web Speech API's SpeechRecognition expects.
const recognitionLangs = {
  eng: 'en-US',
  nld: 'nl-NL',
  spa: 'es-ES',
  por: 'pt-PT',
  rus: 'ru-RU',
  deu: 'de-DE',
  fra: 'fr-FR',
  ita: 'it-IT',
  jpn: 'ja-JP',
  cmn: 'zh-CN',
  vie: 'vi-VN',
  kor: 'ko-KR',
  ara: 'ar-SA',
  ell: 'el-GR',
  swe: 'sv-SE',
  tur: 'tr-TR',
}

export default recognitionLangs
